export const fr = {
  welcome: "Bienvenue sur",
  limit: "Limite: ",
  exclusive: "Exclusif à: ",
};
